import React, { useContext } from "react";
import { RicosContext } from "./../../../ricos-context";
import { ToggleButton } from "../../components";
import { TrashIcon } from "../../icons";
const DeleteButton = ({ toolbarItem, dataHook }) => {
  const { t } = useContext(RicosContext) || {};
  const onClick = toolbarItem.commands.click;
  return /* @__PURE__ */ React.createElement(
    ToggleButton,
    {
      Icon: TrashIcon,
      onClick: () => onClick ? onClick() : toolbarItem.commands.delete(),
      dataHook,
      tooltip: t("DeleteButton_Tooltip")
    }
  );
};
var DeleteButton_default = DeleteButton;
export {
  DeleteButton_default as default
};
//# sourceMappingURL=DeleteButton.js.map
